// Fichier : Experience/Transition.js (Nouvelle classe)

import * as THREE from "three";
import { gsap } from "gsap";

import preloaderFragmentShader from "../shaders/preloader/fragment.glsl";
import preloaderVertexShader from "../shaders/preloader/vertex.glsl";

export default class Transition {
  constructor(scene, experience) {
    this.experience = experience;

    this.sizes = this.experience.sizes;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    this.scene = scene; // On utilise la scène de l'Experience !

    this.duration = 1.25;

    this.debugParams = {
      noiseAmp: 5.0,
      noiseMin: 0.0,
      noiseMax: 1.0,
      smoothness: 0.1,
      threshold1: 0.0,
      threshold2: 0.99,
    };

    this.setMesh();
    if (this.debug && this.debug.ui) {
      // this.setDebug();
    }
  }

  setMesh() {
    this.overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1);
    this.overlayMaterial = new THREE.ShaderMaterial({
      fragmentShader: preloaderFragmentShader,
      vertexShader: preloaderVertexShader,
      defines: {
        PR: this.sizes.pixelRatio,
      },
      uniforms: {
        uProgress: { value: 1.0 },
        uTime: { value: 0.0 },
        uRes: { value: new THREE.Vector2(this.sizes.width, this.sizes.height) },
        uSeed: { value: Math.random() },

        // Nouveaux uniforms connectés à nos paramètres de debug
        uNoiseAmp: { value: this.debugParams.noiseAmp },
        uNoiseMin: { value: this.debugParams.noiseMin },
        uNoiseMax: { value: this.debugParams.noiseMax },
        uSmoothness: { value: this.debugParams.smoothness },
        uThreshold1: { value: this.debugParams.threshold1 },
        uThreshold2: { value: this.debugParams.threshold2 },
        uDirection: { value: 1.0 },
      },
      transparent: true,
    });
    this.overlay = new THREE.Mesh(this.overlayGeometry, this.overlayMaterial);
    this.scene.add(this.overlay);
  }

  async playIn() {
    this.overlay.visible = true;

    // On configure la direction et une nouvelle graine aléatoire
    this.overlayMaterial.uniforms.uDirection.value = -1.0;
    this.overlayMaterial.uniforms.uSeed.value = Math.random();

    // On peut directement "await" une animation GSAP !
    // Le code va s'arrêter sur cette ligne et attendre la fin de l'animation.
    await gsap.to(this.overlayMaterial.uniforms.uProgress, {
      duration: 1.25,
      value: 1.0,
      ease: "power1.inOut",
    });
  }

  async playOut() {
    // On configure la direction et une nouvelle graine aléatoire
    this.overlayMaterial.uniforms.uDirection.value = 1.0;
    this.overlayMaterial.uniforms.uSeed.value = Math.random();

    await gsap.to(this.overlayMaterial.uniforms.uProgress, {
      duration: 1.25,
      value: 0.0,
      ease: "power1.inOut",
    });

    // L'animation est finie, on peut maintenant cacher l'overlay.
    this.overlay.visible = false;
  }
}
